module.exports = __webpack_public_path__ + "img/card_ip_stipulation55.231400f1.svg";